// Backend base URL — empty string = same origin (local dev).
// In production set VITE_API_URL in Vercel to the Railway backend URL.
const rawApiBase = (import.meta.env.VITE_API_URL ?? "").trim();

const normalizeApiBase = (value: string): string => {
  if (!value) return "";
  const withProtocol = /^https?:\/\//i.test(value) ? value : `https://${value}`;
  return withProtocol.replace(/\/+$/, "");
};

export const API_BASE: string = normalizeApiBase(rawApiBase);
